const menuIcon = () => {
	const domElements = {
		menuIcon: document.querySelector(".js-menu-icon"),
		menuIconClose: document.querySelector(".js-menu-icon-close"),
		menuIconArrows: document.querySelectorAll(".js-menu-icon-arrow"),
		menuIconText: document.querySelector(".js-menu-icon-text"),
		menu: document.querySelectorAll(".js-menu"),
		header: document.querySelector(".js-header"),
	};

	if (
		!domElements.menuIcon ||
		!domElements.menuIconArrows ||
		!domElements.menuIconText ||
		!domElements.menu ||
		!domElements.menu.length ||
		!domElements.header
	)
		return;

	let animating = false;

	domElements.menuIcon.addEventListener("click", () => {
		// Return if we are already animating
		if (animating) return;

		// Force the scroll to the top of the page
		// window.scrollTo(0, 0)

		// Set a variable to check if the menu is active
		const isActive = domElements.menuIcon.classList.contains("is-active");
		animating = true;

		// If active scroll lock the body
		if (isActive) {
			document.getElementsByTagName('html')[0].classList.remove('modal-open');
		} else {
			document.getElementsByTagName('html')[0].classList.add('modal-open');
		}

		// Toggle the active class on the menu icon to animate it
		domElements.menuIconArrows.forEach((arrow) => {
			arrow.classList.toggle("is-active");
		});

		// Toggle the active class on the menu to show/hide it
		domElements.menuIcon.classList.toggle("is-active");
		domElements.header.classList.toggle("is-active");

		domElements.menu.forEach((menu) => {
			menu.classList.toggle("is-active");
		});

		setTimeout(() => {
			domElements.menuIconText.textContent = isActive ? "Menu" : "Close";
		}, 200);

		setTimeout(() => {
			animating = false;
		}, 400);
	});

	domElements.menuIconClose.addEventListener("click", () => {
		// Return if we are already animating
		if (animating) return;

		// Force the scroll to the top of the page
		// window.scrollTo(0, 0)

		// Set a variable to check if the menu is active
		const isActive = domElements.menuIcon.classList.contains("is-active");
		animating = true;

		console.log(isActive)

		// If active scroll lock the body
		if (isActive) {
			document.getElementsByTagName('html')[0].classList.remove('modal-open');
		} else {
			document.getElementsByTagName('html')[0].classList.add('modal-open');
		}

		// Toggle the active class on the menu icon to animate it
		domElements.menuIconArrows.forEach((arrow) => {
			arrow.classList.toggle("is-active");
		});

		// Toggle the active class on the menu to show/hide it
		domElements.menuIcon.classList.toggle("is-active");
		domElements.header.classList.toggle("is-active");

		domElements.menu.forEach((menu) => {
			menu.classList.toggle("is-active");
		});

		setTimeout(() => {
			domElements.menuIconText.textContent = isActive ? "Menu" : "Close";
		}, 200);

		setTimeout(() => {
			animating = false;
		}, 400);
	});
};

export { menuIcon };
